<template>
  <v-container
    class="white black--text corners"
    style="margin-top: 220px"
    id="email"
  >
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="email_fields.fullname"
        :counter="10"
        :rules="nameRules"
        label="From Name"
        required
      ></v-text-field>

      <v-text-field
        v-model="email_fields.email"
        :rules="emailRules"
        label="From E-mail"
        required
      ></v-text-field>
      <v-textarea
        :rules="suggRules"
        class="mt-4"
        outlined
        counter="2000"
        auto-grow
        name="input-7-4"
        label="Email Body"
        v-model="email_fields.body"
      ></v-textarea>

      <v-btn
        small
        elevation="2"
        class="blue accent-3 white--text"
        @click="send"
      >
        Send
      </v-btn>
      <v-btn
        small
        elevation="2"
        class="blue accent-3 white--text ml-2"
        @click="cancel"
      >
        Cancel
      </v-btn>
    </v-form>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
.corners {
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: 3px solid black;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "email_brand",
  mixins: [bus_common],
  data: () => ({
    valid: true,
    new_email: {
      fullname: "John Molt",
      email: "jvonmolt@gmail.com",
      body: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit, tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit, quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos  sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam recusandae alias error harum maxime adipisci amet laborum. Perspiciatis  minima nesciunt dolorem! Officiis iure rerum voluptates a cumque velit `,
    },
    email_fields: {
      fullname: "",
      email: "",
      body: "",
    },
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 120) || "Name must be less than 120 characters",
    ],
    suggRules: [
      (v) => !!v || "Your Suggestion is required",
      (v) =>
        (v && v.length <= 2000) ||
        "Your suggestion must be less than 2000 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
  }),
  methods: {
    cancel() {
      this.$router.push({
        path: "/",
        query: { token: this.$store.state.user.token },
      });
    },
    save_ti_edit() {
      //   this.mrbreakpoint("save_ti_edit");
      var self = this;
      this.ti_text = "";
      this.show_ti_diag = false;
      this.show_loader(true);
      // this.("debug");
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.email_fields = this.email;
      formIn.hdr = this.mno(this.ti_diag.header_current.header);
      //console.log("Save ti edit test: " + formIn.ti.text_current.text_content);
      if (formIn.ti.text_current.text_content.indexOf("<p>") == -1) {
        // this.swall_it(
        //   "Cannot Save yet",
        //   "Please edit the text before trying to save.",
        //   "error",
        //   null,
        //   null
        // );
        formIn.ti.text_current.text_content =
          "<p>" + formIn.ti.text_current.text_content + "</p>";
        //return true;
      }

      formIn.apiname = "save_ti_edit";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (formIn.ti.text_current.resource_type == "peer") {
            self.update_peer = new Date();
          }
          if (formIn.ti.text_current.resource_type == "physical") {
            self.update_physical = new Date();
          }
          if (formIn.ti.text_current.resource_type == "spiritual") {
            self.update_spiritual = new Date();
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    send() {
      this.show_loader(false);
      let val = this.$refs.form.validate();
      console.log("val: " + val);
      if (val == false) {
        return true;
      }
      var self = this;
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.email_fields = this.email_fields;

      formIn.apiname = "email_send_brand";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);

          self.email = this.mno(this.new_email);
          self.swall_it("Email Status", "Email Sent.", "success", null, null);
          self.$router.push({
            path: "/",
            query: { token: this.$store.state.user.token },
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      this.email_fields = this.mno(this.new_email);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
